module.exports = __webpack_public_path__ + "media/images/ui__arrowUpInactive-8329e4cc390d540ff2e34425cb216f3a.png";